exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".webix_cell, .webix_hcell {\n  font-size: 15px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/components/graphs/comparedate-table/comparedate-table.component.scss
// module id = ../../../../../src/app/shared/components/graphs/comparedate-table/comparedate-table.component.scss
// module chunks = main